export default __webpack_public_path__ + "static/media/en.2e689d49.svg";